import { Tag } from '@src/data/exercise-response'
import { Unit } from '@src/util/constants'

export default class Activity {

  id: number
  key: string
  level: string
  image2x: string
  image3x: string
  exerciseTags: Tag[]
  unit: Unit
  unitDenominator: number

  constructor (attributes?) {
    Object.assign(this, attributes)
  }
}
